var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosedOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.6641,
    cy: 32.1172,
    r: 32,
    fill: "#E6F4FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6609 15.832C23.6811 15.832 16.375 23.1381 16.375 32.1179C16.375 41.0977 23.6811 48.4038 32.6609 48.4038C41.6407 48.4038 48.9468 41.0977 48.9468 32.1179C48.9468 23.1381 41.6407 15.832 32.6609 15.832ZM39.7189 28.9635L31.576 38.3592C31.2327 38.7525 30.7442 38.9881 30.223 39.0056C30.2005 39.0056 30.1779 39.0056 30.1554 39.0056C29.6568 39.0056 29.1782 38.8077 28.8274 38.4544L24.4428 34.0697C23.7087 33.3356 23.7087 32.1455 24.4428 31.4114C25.1769 30.6772 26.367 30.6772 27.1011 31.4114L30.0602 34.3679L36.8802 26.498C37.5592 25.7163 38.7443 25.6286 39.531 26.3076C40.3128 26.9941 40.3979 28.1792 39.7189 28.9635Z",
    fill: "#2995DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedOrders);
export default __webpack_public_path__ + "static/media/closedOrders.1b660fbb8f4bc16e2ca61ff1223fbe6b.svg";
export { ForwardRef as ReactComponent };